
import { CreditApplicationDocument, RequiredDocument, RequiredDocumentWithStatus } from '@applyonline/shared/types'
import { useMemo } from 'react'
import { buildRequiredDocumentsWithStatus } from './creditapp-selectors'

export default function useRequiredDocumentsWithStatus(
  requiredDocuments: RequiredDocument[] | undefined | null,
  documents: CreditApplicationDocument[] | undefined | null,
): RequiredDocumentWithStatus[] {
  return useMemo(() => {
    return buildRequiredDocumentsWithStatus(requiredDocuments, documents)
  }, [requiredDocuments, documents])
}
